import { useCallback } from 'react';

import { getQuickRepliesApi } from '../api';
import { useSelector, useDispatch } from '../../../react-redux';
import { getQuickReply } from '../../../reducers/quick-reply';
import { makeSortQuickReply } from '../selector';

const getSortReply1 = makeSortQuickReply();
const getSortReply2 = makeSortQuickReply();

const useQuickReply = () => {
  const myQuickReply = useSelector(state => state.getIn(['quickReply', 'myQuickReply']));
  const enterpriseQuickReply = useSelector(state => state.getIn(['quickReply', 'enterpriseQuickReply']));

  const dispatch = useDispatch();

  const handleUpdateReply = useCallback(
    ({ type, data }) => {
      switch (type) {
        case 'my':
          dispatch(
            getQuickReply({
              agent_quick_reply_group: data,
              ent_quick_reply_group: enterpriseQuickReply
            })
          );
          break;
        case 'enterprise':
          dispatch(
            getQuickReply({
              agent_quick_reply_group: myQuickReply,
              ent_quick_reply_group: data
            })
          );
          break;
        default:
          break;
      }
    },
    [myQuickReply, enterpriseQuickReply]
  );

  const handleGetReply = useCallback(
    (ismemo = false) => {
      if (!ismemo) {
        return getQuickRepliesApi().then(res => {
          if (res && res.data) {
            const { agent_quick_reply_group, ent_quick_reply_group } = res.data;
            dispatch(
              getQuickReply({
                agent_quick_reply_group: getSortReply1(agent_quick_reply_group),
                ent_quick_reply_group: getSortReply2(ent_quick_reply_group)
              })
            );
          }
        });
      } else if (!enterpriseQuickReply?.length && !myQuickReply?.length)
        return getQuickRepliesApi().then(res => {
          if (res && res.data) {
            const { agent_quick_reply_group, ent_quick_reply_group } = res.data;
            dispatch(
              getQuickReply({
                agent_quick_reply_group: getSortReply1(agent_quick_reply_group),
                ent_quick_reply_group: getSortReply2(ent_quick_reply_group)
              })
            );
          }
        });
    },
    [myQuickReply, enterpriseQuickReply]
  );

  return {
    myQuickReply,
    enterpriseQuickReply,
    handleGetReply,
    handleUpdateReply
  };
};

export default useQuickReply;
